export default __webpack_public_path__ + "static/media/document-icon.d7970fa2.svg";